"use strict";

import "./POICollaborators.css";
import React from "react";
import classnames from "classnames";
import dispatcher from "./../../dispatcher";
import poiCollaborationStore from "./../../store/poiCollaborations";
import userStore from "./../../store/users";
import {getPrivilegeOfPOI} from "./../../utils/poi";
import getPOICollaborations from "./../../api/getPOICollaborations";
import lang from "vwa/lang";
import api from "vwa/api";
import ProgressBar from "vwa/components/ProgressBar";
import Toast from "vwa/components/Toast";
import Button from "vwa/components/Button";
import EEP from "vfu/EEP";
import CollaboratorCard from "./CollaboratorCard";
import ShareDialog from "./ShareDialog";
import Dialog from "vwa/components/Dialog";

import addPOICollaboration from "./../../api/addPOICollaboration";
import clearPOICollaboration from "./../../api/clearPOICollaboration";
import updatePOICollaboration from "./../../api/updatePOICollaboration";

export default class POICollaborators extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
		this.eep = new EEP();
		this.setStoreListeners();
	}
	
	initState() {
		this.state = {
			inProgress:			false,
			displayButton:		true,
			collaborations:		this.getCollaborationsFromStore(),
			users:				userStore.getAll(),
			inShare:			false
		};
	}
	
	getCollaborationsFromStore() {
		return poiCollaborationStore.get(this.props.poiId).getAll() || [];
	}
	
	setStoreListeners() {
		this.eep.on(poiCollaborationStore.get(this.props.poiId), 'change', collaborations => {
			this.setState({collaborations: collaborations});
		});
	}
	
	componentDidMount() {
		this.createScrollHandler();
		this.getPOICollaborations();
	}
	
	componentWillUnmount() {
		this.eep.close();
	}
	
	createScrollHandler() {
		
		let lastScrollTop = 0;
		
		this.handleScroll = () => {
			if (this.refs.content.scrollTop <= 30) {
				this.setState({displayButton: true});
			}
			else {
				if (this.refs.content.scrollTop > lastScrollTop)
					this.setState({displayButton: false});
				else
					this.setState({displayButton: true});
			}
			lastScrollTop = this.refs.content.scrollTop;
		};
	}
	
	async getPOICollaborations() {
		this.setState({inProgress: true});
		await getPOICollaborations(this.props.poiId);
		this.setState({inProgress: false});
	}
	
	async updateCollaboration(collaboratorId, privilege) {
		this.setState({inProgress: true});
		await updatePOICollaboration(this.props.poiId, collaboratorId, privilege);
		this.setState({inProgress: false});
	}
	
	async clearCollaboration(collaboratorId) {
		this.setState({inProgress: true});
		await clearPOICollaboration(this.props.poiId, collaboratorId);
		this.setState({inProgress: false});
	}
	
	async addCollaboration(collaboration) {
		this.setState({inProgress: true});
		const result = await addPOICollaboration(this.props.poiId, collaboration);
		if (result === true)
			this.setState({inShare: false});
		this.setState({inProgress: false});
	}
	
	getPossibleCollaborators() {
		if (!this.state.users)
			return [];
		
		return this.state.users
						.filter(user => {
							if (!this.state.collaborations)
								return true;
							return !this.state.collaborations.find(c => c.collaborator == user._id);
						})
						.map(user => ({
							id:			user._id,
							name:		getNameOfUser(user._id),
							isGroup:	getTypeOfUser(user._id) == "UserGroup"
						}));
	}
	
	isButtonHidden() {
		return !this.state.displayButton;
	}
	
	isButtonDisabled() {
		return getPrivilegeOfPOI(this.props.poiId) < 3 || this.getPossibleCollaborators().length == 0;
	}
	
	renderCard(collaboration) {
		return (
			<CollaboratorCard
				key={collaboration.collaborator}
				name={getNameOfUser(collaboration.collaborator)}
				privilege={collaboration.privilege}
				isGroup={getTypeOfUser(collaboration.collaborator) == "UserGroup"}
				onChange={privilege => this.updateCollaboration(collaboration.collaborator, privilege)}
				onClear={() => this.clearCollaboration(collaboration.collaborator)}
				canClear={canChangeCollaboration(this.props.poiId, collaboration)}
				canChange={canChangeCollaboration(this.props.poiId, collaboration)}
			/>
		);
	}
	
	renderCards() {
		return this.state.collaborations ? this.state.collaborations.map(this.renderCard.bind(this)) : null;
	}
	
	render() {
		return (
			<div className="POICollaborators">
				<Button
					icon="account-plus"
					className={classnames("Floating", "Red", {"Hidden": this.isButtonHidden()})}
					title={lang.ADD_COLLABORATOR}
					disabled={this.isButtonDisabled()}
					onClick={_ => this.setState({inShare: true})}
				/>
				<ProgressBar
					indeterminate
					shown={this.state.inProgress}
				/>
				<div
					ref="content"
					onScroll={() => this.handleScroll()}
					className={classnames("Content", {"Hidden": this.state.inProgress})}
				>
					{this.renderCards()}
				</div>
				<ShareDialog
					shown={this.state.inShare}
					maxPrivilege={getPrivilegeOfPOI(this.props.poiId)}
					possibleCollaborators={this.getPossibleCollaborators(this.props.poiId)}
					onCancel={() => this.setState({inShare: false})}
					onShare={collaboration => this.addCollaboration(collaboration)}
				/>
			</div>
		);
	}
	
}

POICollaborators.propTypes = {
	poiId:	React.PropTypes.string
};

POICollaborators.defaultProps = {
	poiId:	null
};

function getNameOfUser(userId) {
	const collaborator = userStore.get(userId);
	if (!collaborator)
		return lang.UNKNOWN;
	
	if (collaborator.type == "UserGroup")
		return collaborator.name;
	else if (collaborator.type == "User")
		return collaborator.firstName + " " + collaborator.lastName;
	
	return lang.UNKNOWN;
}

function getTypeOfUser(userId) {
	const collaborator = userStore.get(userId);
	if (!collaborator)
		return null;
	return collaborator.type || null;
}

function canChangeCollaboration(poiId, collaboration) {
	const myPrivilege = getPrivilegeOfPOI(poiId);
	if (isItTheLastOwner(poiId, collaboration))
		return false;
	if (myPrivilege == 4)
		return true;
	if (myPrivilege == 3 && collaboration.privilege < 4)
		return true;
	return false;
}

function isItTheLastOwner(poiId, collaboration) {
	const collaborations = poiCollaborationStore.get(poiId).getAll();
	if (!collaborations)
		return false;
	
	const ownerships = collaborations.filter(c => c.privilege == 4);
	if (collaboration.privilege == 4 && ownerships.length == 1)
		return true;
	else return false;
}


// WEBPACK FOOTER //
// ./src/view/POICollaborators/POICollaborators.jsx